import React, {useContext, useState} from 'react'
import utils from '@eitje/utils'

const NotifContext = React.createContext({})
const NotifProvider = NotifContext.Provider

const MAX_NOTIF_AMOUNT_PER_TYPE = 5

const useConcatState = () => {
	const [state, setState] = useState([])
	const setConcatState = newEl => setState(prevState => [...prevState, newEl])
	const delItem = (item, identifier) => setState(state.filter(i => (identifier ? i[identifier] !== item : i !== item)))
	return [state, setConcatState, delItem]
}

const getNextId = items => {
	if (!items.length) return 1
	return Math.max(...items._map('id')) + 1
}

export let addNotif = () => {}

const formatNotifKey = item => item.title + '|' + item.content

const countNotifTypes = notifications => {
	const titleContentCount = {}

	notifications.forEach(item => {
		const key = formatNotifKey(item)
		titleContentCount[key] = (titleContentCount[key] || 0) + 1
	})

	return titleContentCount
}

export const NotificationProvider = ({children}) => {
	const [notifications, setConcatNotifications, removeNotif] = useConcatState()
	const [centerNotifications, setConcatCenterNotifications, removeCenterNotif] = useConcatState()

	const addNotification = item => {
		const titleContentCount = countNotifTypes(notifications)

		const key = formatNotifKey(item)
		const count = titleContentCount[key] || 0
		if (count >= MAX_NOTIF_AMOUNT_PER_TYPE) return

		setConcatNotifications({...item, id: utils.randomId()})
	}

	const removeNotification = id => {
		removeNotif(id, 'id')
	}

	const addCenterNotification = item => {
		setConcatCenterNotifications({
			...item,
			id: getNextId(centerNotifications),
		})
	}

	const removeCenterNotification = id => {
		removeCenterNotif(id, 'id')
	}

	addNotif = item => {
		item.position === 'center' ? addCenterNotification(item) : addNotification(item)
	}

	const contextValue = {
		notifications,
		centerNotifications,
		addNotification,
		removeNotification,
		addCenterNotification,
		removeCenterNotification,
	}

	return <NotifProvider value={contextValue}>{children}</NotifProvider>
}

export const useNotifContext = () => {
	return useContext(NotifContext)
}
